import { render, staticRenderFns } from "./VaNotification.vue?vue&type=template&id=68eed4bb&"
import script from "./VaNotification.vue?vue&type=script&lang=js&"
export * from "./VaNotification.vue?vue&type=script&lang=js&"
import style0 from "./VaNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports